import type XertPusher from './xert-pusher';

import { get, readable } from 'svelte/store';
import { getRequest, isUserInSession } from './Util/utils';
import route from './Util/routes';

export function getSessionTemplateStore(pusher: XertPusher, user_params, getSessionTemplate: any, manual_event_control: any) {
    var templates = [];
    const initial = fetch(route('SessionsController@getSessionTemplates'), getRequest()).then(v=>v.json());
    manual_event_control.initial = initial;
    return readable([], function start(set) {
        initial.then(data=>{
            templates = data;
            set(templates);
        });
        let channel = pusher.getChannel("all_session_templates");

        const debounce_ids: string[] = [];
        let debounce_promise: Promise<unknown> = Promise.resolve(true);

        let do_get_session = (id)=>{
            return getSessionTemplate(id)
            .catch(error=>{})
            .then(new_session => {
                if (new_session == null) return;

                let index = templates.findIndex(s=>s.template_id == id);
                //console.log(`session[${index}]: ${JSON.stringify(new_session)}`);
                if (index != -1) {
                    templates[index] = new_session;
                } else {
                    templates.push(new_session);
                }
                set(templates);
            });
        }

        let callback = event =>{
            if (event.session != null) {
                let new_session = event.session
                let id = new_session.template_id;

                if (event.action === "delete") {
                    templates = templates.filter(s=>s.template_id != id);
                    set(templates);
                } else {
                    // request session details from server.
                    let owner_id = get(user_params).user_id;
                    //let clubs = get(user_params).club_ids;
                    if (owner_id != null && !((owner_id === new_session?.owner?.id))) {
                        //(new_session.sharing_type === "public") ||
                        //(clubs.includes(new_session.community)) ||
                        //(new_session.allowed_users ?? []).includes(owner_id) ||
                        //(new_session.members ?? []).findIndex(v=>v.id==owner_id)!=-1)) {
                        return;
                    }

                    if (!debounce_ids.includes(id)) {

                        debounce_ids.push(id);
                        debounce_promise = debounce_promise.then(async ()=>{
                            const id = debounce_ids[0];
                            const result = await do_get_session(id);
                            debounce_ids.shift()
                            return result;
                        });
                    }

                }
            } else if (event.sessions != null) {
                templates = event.sessions;
                set(templates);
            }
        };
        manual_event_control.postSessionTemplate = function(template) {
            callback({template: template});
        }
        manual_event_control.postSessionTemplates = function(ss) {
            templates = ss;
            set(templates);
        }
        let event_name = "sessions";
        channel.bind(event_name, callback);

        return function stop() {
            manual_event_control.postSessionTemplate = null;
            channel.unbind(event_name, callback);
        };
    });
}

export default function getSessionStore(pusher: XertPusher, user_params, getSession: any, manual_event_control: any) {
    var sessions = [];
    return readable([], function start(set) {
        const initial = fetch(route('SessionsController@getSessions'), getRequest()).then(v=>v.json())
        initial.then(data=>{
            sessions = data;
            set(sessions);
        });
        let channel = pusher.getChannel("all_sessions");

        const debounce_ids: string[] = [];
        let debounce_promise: Promise<unknown> = Promise.resolve(true);

        const update_sessions = (data) => {
            if (data == null || data.length == 0) return;
            let need_sort = false;
            for (const new_session of data) {
                const id = new_session.session_id;

                let was_joined = false;
                const index = sessions.findIndex(s=>s.session_id == id);
                //console.log(`session[${index}]: ${JSON.stringify(new_session)}`);
                if (index != -1) {
                    const d1 = new Date(sessions[index].start_date);
                    const d2 = new Date(new_session.start_date);
                    const old_session = sessions[index];
                    was_joined = isUserInSession(old_session);
                    sessions[index] = new_session;
                    // Re-sort by date if date changed.
                    if (d1 != d2) {
                        need_sort = true
                    }
                } else {
                    sessions.push(new_session);
                    need_sort = true;
                }
                // Update to joined session, used to refresh recommended training.
                const joined = isUserInSession(new_session);
                if (was_joined || joined) {
                    manual_event_control.onUpdate(new_session);
                }
            }
            if (need_sort) {
                sessions = sessions.sort((a, b) => Date.parse(a.start_date) - Date.parse(b.start_date) );
            }
            set(sessions);

        }

        const do_get_session = (id)=>{
            return getSession(id)
            .then((v)=>update_sessions([v]))
            .catch(error=>{
                console.error(error);
            });
        }

        let callback = event =>{
            if (event.session != null) {
                let new_session = event.session
                let id = new_session.session_id;

                if (event.action === "delete") {
                    const index = sessions.findIndex(s=>s.session_id == id);
                    if (index != -1) {
                        // Joined session deleted.
                        const old_session = sessions[index];
                        if (isUserInSession(old_session)) {
                            manual_event_control.onUpdate(old_session);
                        }
                        sessions.splice(index, 1);
                    }

                    set(sessions);
                } else {

                    // request session details from server.
                    let owner_id = get(user_params).user_id;
                    let clubs = get(user_params).club_ids;
                    if (owner_id != null && !(
                        (owner_id === new_session?.owner?.id) ||
                        (new_session.sharing_type === "public") ||
                        (clubs.includes(new_session.community)) ||
                        (new_session.allowed_users ?? []).includes(owner_id) ||
                        (new_session.members ?? []).findIndex(v=>v.id==owner_id)!=-1)) {
                        return;
                    }

                    if (!debounce_ids.includes(id)) {

                        debounce_ids.push(id);
                        debounce_promise = debounce_promise.then(async ()=>{
                            const id = debounce_ids[0];
                            const result = await do_get_session(id);
                            debounce_ids.shift()
                            return result;
                        });
                    }

                }
            } else if (event.sessions != null) {
                sessions = event.sessions;
                set(sessions);
            }
        };
        manual_event_control.postSession = function(session) {
            callback({session: session});
        }
        manual_event_control.postSessionsDirectly = function(sessions) {
            update_sessions(sessions)
        }
        manual_event_control.postSessions = function(ss) {
            sessions = ss;
            set(sessions);
        }
        let event_name = "sessions";
        channel.bind(event_name, callback);

        return function stop() {
            manual_event_control.postSession = null;
            channel.unbind(event_name, callback);
        };
    });

}

export function getNotificationsStore(pusher: XertPusher, user_params) {
    return readable(null, function start(set) {
        let event_name = "sessions_alert";
        let channel = pusher.getUserChannel();
        channel.bind(event_name, set);

        return function stop() {
            channel.unbind(event_name, set);
        };
    });
}